export enum StatusEnum {
	READY = 'ready',
	SEEN = 'seen',
	UNSEEN = 'unseen',
}
